// src/pages/ProfilePage/ProfilePage.styles.ts
import styled from "styled-components";
import { pxToRem } from "../../styles/utils";

export const ProfilePageContainer = styled.div`
  display: flex;
  height: calc(100% - ${pxToRem(24)});
  margin: ${pxToRem(12)};
`;

export const ContentWrapper = styled.div`
  // flex: 1;
  display: flex;
  flex-direction: column;
  margin-left: 0;
  background: white;
  border-radius: ${pxToRem(16)};
  box-shadow: 
    0px ${pxToRem(9)} ${pxToRem(14.5)} rgba(0, 0, 0, 0.06),
    0px 0px ${pxToRem(6)} rgba(31, 10, 53, 0.05);
  padding: ${pxToRem(32)} ${pxToRem(25)};
  box-sizing: border-box;
  width: calc(100% - ${pxToRem(60)});
`;

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${pxToRem(32)};
`;
export const Title = styled.h1`
  font-size: ${pxToRem(32)};
  font-weight: 700;
  color: rgb(31, 10, 53);
`;

export const ButtonWrapper = styled.div``;

export const TariffCardsContainer = styled.div`
  display: flex;
  flex: none;
  gap: ${pxToRem(14)};
  padding: ${pxToRem(10)} ${pxToRem(10)};
  overflow-x: auto;

  &::-webkit-scrollbar {
    height: ${pxToRem(8)};
  }
  &::-webkit-scrollbar-thumb {
    background-color: rgb(114, 82, 220);
    border-radius: ${pxToRem(4)};
  }
  &::-webkit-scrollbar-track {
    background-color: rgba(114, 82, 220, 0.1);
    border-radius: ${pxToRem(4)};
  }
  scrollbar-color: rgb(114, 82, 220) rgba(114, 82, 220, 0.1);
  scrollbar-width: thin;
`;

export const TableContainer = styled.div`
  margin-top: ${pxToRem(32)};
  flex: 1;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;

  -ms-overflow-style: none;
  scrollbar-width: none;
  &::-webkit-scrollbar { display: none; }
`;

export const FeatureTable = styled.table`
  width: 100%;
  border-collapse: collapse;

  thead th:first-child,
  tbody td:first-child {
    width: ${pxToRem(500)};
    max-width: ${pxToRem(500)};
    white-space: normal;
    word-break: break-word;
    overflow-wrap: break-word;
  }

  thead tr {
    & > th:first-child { text-align: left; }
    & > th:not(:first-child) { text-align: center; }
  }

  tbody tr {
    & > td:first-child { text-align: left; }
    & > td:not(:first-child) { text-align: center; }
  }
`;

export const TableHead = styled.thead``;

export const TableBody = styled.tbody``;

export const TableRow = styled.tr``;

export const TableHeader = styled.th`
  padding: ${pxToRem(12)};
  font-size: ${pxToRem(23)};
  border-bottom: 1px solid rgba(31, 10, 53, 0.1);
  font-weight: 700;
  color: rgb(0, 0, 0);
  text-align: left;
  position: sticky;
  top: 0;
  background: white;
  z-index: 2;
`;

export const TableData = styled.td`
  padding: ${pxToRem(12)};
  padding-top: ${pxToRem(23)};
  font-size: ${pxToRem(22)};
  border-bottom: 1px solid rgba(31, 10, 53, 0.1);
  font-weight: 500;
  color: rgb(0, 0, 0);
  text-align: left;
`;

export const TableDataCenter = styled(TableData)`
  text-align: center;
`;
